/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/app'
import { Route as DocsRouteImport } from './routes/docs'
import { Route as AppIndexRouteImport } from './routes/app.index'
import { Route as AppNewRouteImport } from './routes/app.new'
import { Route as AppVaultIdRouteImport } from './routes/app.vault.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRoute = DocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppNewRoute = AppNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppRoute,
} as any)
const AppVaultIdRoute = AppVaultIdRouteImport.update({
  id: '/vault/$id',
  path: '/vault/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/docs': typeof DocsRoute
  '/app/new': typeof AppNewRoute
  '/app/': typeof AppIndexRoute
  '/app/vault/$id': typeof AppVaultIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/docs': typeof DocsRoute
  '/app/new': typeof AppNewRoute
  '/app': typeof AppIndexRoute
  '/app/vault/$id': typeof AppVaultIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteWithChildren
  '/docs': typeof DocsRoute
  '/app/new': typeof AppNewRoute
  '/app/': typeof AppIndexRoute
  '/app/vault/$id': typeof AppVaultIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/app' | '/docs' | '/app/new' | '/app/' | '/app/vault/$id'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/docs' | '/app/new' | '/app' | '/app/vault/$id'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/docs'
    | '/app/new'
    | '/app/'
    | '/app/vault/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  DocsRoute: typeof DocsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/new': {
      id: '/app/new'
      path: '/new'
      fullPath: '/app/new'
      preLoaderRoute: typeof AppNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/vault/$id': {
      id: '/app/vault/$id'
      path: '/vault/$id'
      fullPath: '/app/vault/$id'
      preLoaderRoute: typeof AppVaultIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppNewRoute: typeof AppNewRoute
  AppIndexRoute: typeof AppIndexRoute
  AppVaultIdRoute: typeof AppVaultIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppNewRoute: AppNewRoute,
  AppIndexRoute: AppIndexRoute,
  AppVaultIdRoute: AppVaultIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  DocsRoute: DocsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
